import { action } from '@play-co/replicant';
import createActions from './utils/createActions';
import { stateSchema } from '../State';
import { duration } from '../utils/duration';

export default createActions({
  updateUserClientSideData: action(
    (state, args: { timezoneOffsetMs?: number; timeZone?: string }, api) => {
      if (args.timezoneOffsetMs !== undefined) {
        state.timezoneOffsetMs = args.timezoneOffsetMs;
      }
      if (args.timeZone !== undefined) {
        state.timeZone = args.timeZone;
      }
    },
  ),

  setDeleteAccountIntent: action((state, intent: boolean, api) => {
    if (intent) {
      state.deleteAccountIntent = api.date.now();
    } else {
      delete state.deleteAccountIntent;
    }
  }),

  deleteAccount: action((state, _, api) => {
    if (
      !(api.date.now() - state.deleteAccountIntent < duration({ minutes: 1 }))
    ) {
      throw new Error('Unintended account deletion request');
    }

    api.sendAnalyticsEvents([
      {
        eventType: 'AccountDelete',
        eventProperties: {},
      },
    ]);

    // Out with previous state.
    Object.keys(state).forEach((key) => delete state[key]);

    // In with the default state.
    Object.assign(state, stateSchema.getDefault());

    // Nuke metadata
    api.nukeUserMetainfo();
  }),
});
